import { render, staticRenderFns } from "./SeeBindGoods.vue?vue&type=template&id=bcfd676c&scoped=true&"
import script from "./SeeBindGoods.vue?vue&type=script&lang=ts&"
export * from "./SeeBindGoods.vue?vue&type=script&lang=ts&"
import style0 from "./SeeBindGoods.vue?vue&type=style&index=0&id=bcfd676c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfd676c",
  null
  
)

export default component.exports